import { render, staticRenderFns } from "./SrMasterClassification.vue?vue&type=template&id=77a045d1&"
import script from "./SrMasterClassification.vue?vue&type=script&lang=js&"
export * from "./SrMasterClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports